<template>
  <div>
    <h2>Download Microsatellite Data</h2>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-form :inline="true" size="medium">
          <div style="margin-bottom: 10px; font-size: 1.1em;">Showing {{ store.settings.speciesTableCurrentStart + 1 }} to {{ store.settings.speciesTableCurrentStop > paginationTotal ? paginationTotal : store.settings.speciesTableCurrentStop }} species of {{ paginationTotal }}</div>
          <el-form-item>
            <el-input placeholder="Search species by name..." v-model="store.settings.speciesTableSearchString" @change="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-tooltip content="Click or Press Enter to search" placement="top">
              <el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-pagination background :page-size.sync="store.settings.speciesTablePageSize" @size-change="handleSizeChange" :current-page.sync="store.settings.speciesTableCurrentPage" @current-change="handlePageChange" :page-sizes="store.settings.speciesTablePageSizeOptions" :total="paginationTotal" layout="jumper, prev, pager, next, sizes" :pager-count="5">
          <span>Slot Test</span>
            </el-pagination>
          </el-form-item>
          <el-form-item label="Sort Species By">
            <el-select v-model="store.settings.speciesTableSortBy" @change="handleSortChange">
              <el-option label="Selection" value="selected"></el-option>
              <el-option v-for="option in store.species.table.columns.filter(c => c.sortable)" :key=option.name :label="option.label" :value="option.name"></el-option>
            </el-select>
            <el-checkbox label="Ascending" :disabled="store.settings.speciesTableSortBy === 'selected'" style="margin-left: 10px;" true-label="asc" false-label="desc" v-model="store.settings.speciesTableSortDirection" @change="handleSortChange"></el-checkbox>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1">
        <el-table :data="store.species.displayed" size="mini" border :header-cell-style="headerStyle" >
          <el-table-column v-for="col in activeColumns" :key="col.name" :prop="col.name" :label="col.label" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="Actions" fixed="right" width="350" header-align="center">
            <template slot-scope="action">
              <div class="download-actions">
              <a :href="`${store.settings.backendBaseURL}${action.row.MSDBID}`" target="_blank">View Repeats</a>
              <a :href="`${store.settings.downloadBaseURL}${action.row.MSDBID}_perf.tsv`">Download .tsv</a>
              <a :href="`${store.settings.downloadBaseURL}${action.row.MSDBID}_perf.tsv.gz`">Download .tsv.gz</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div style="color: white; hieght: 100px; background-color: #324157; padding: 20px; margin-top: 60vh">
      <div style="padding: 3px"> Copyright 2019 © CCMB, Uppal Road, Hyderabad - 500007, Telangana, India</div>
      <div style="padding: 3px"> MSDB V3 </div>
      <div style="padding: 3px"> Last updated 3rd September 2019 </div>
    </div>
  </div>
</template>

<script>
import { store } from '../scripts/store.js'

import SpeciesSelect from '../components/SpeciesSelect.vue'

export default {
  name: 'Download',
  data () {
    return {
      store: store,
      headerStyle: {
        "background-color": "#EEF1F6",
        "color": "#324157",
        "font-weight": "bold",
        "font-size": "1.2em",
        "border": "1px solid #dcdcdc",
      }
    }
  },
  components: { SpeciesSelect },
  computed:{
    paginationTotal () {
      return _.filter(store.species.list, 'show').length
    },
    activeColumns () {
      return _.filter(store.species.table.columns, 'show')
    }
  },
  methods: {
    handleSizeChange () {
      store.getDisplayedSpecies('Page Size Change')
    },
    handlePageChange () {
      store.getDisplayedSpecies('Current Page Change')
    },
    handleSortChange (value) {
      if (store.settings.debug) {
        console.log(`Sort order changed to ${value}`)
      }
      store.sortSpeciesList('Species Table Sort Select')
    },
    handleSearch () {
      store.searchSpecies('Search Box')
    }
  }
}
</script>

<style>
.download-actions a {
  margin-left: 10px;
  font-size: 1.2em;
  color: #324157;
}
</style>
